import { Injectable } from '@angular/core';
import { combineLatest, of } from 'rxjs';

import { Actions, Effect, ofType } from '@ngrx/effects';
import { catchError, distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';

import {
  BestSellingProductsActionTypes,
  LoadBestSellingProducts,
  LoadBestSellingProductsFailure,
  LoadBestSellingProductsSuccess,
} from './best-selling-products.actions';
import { BestSellingProductsService } from '~app/modules/custom-hub/services';
import { Product } from '~shared/models';
import { PriceTypeService } from '~shared/modules/price-type-toggler/services/price-type.service';
import { getConfigCategories } from '../hub';

@Injectable()
export class BestSellingProductsEffects {

  @Effect()
  loadBestSellingProducts$ = this.actions$.pipe(
    ofType(BestSellingProductsActionTypes.LOAD_BEST_SELLING_PRODUCTS),
    map((action: LoadBestSellingProducts) => action.payload.categorySlugs),
    switchMap((slugs: string[]) => {
      return this.bestSellingProductsService.getProducts(slugs).pipe(
        map((products: Product[]) => new LoadBestSellingProductsSuccess({ products })),
        catchError(error => of(new LoadBestSellingProductsFailure({ error })))
      );
    })
  );

  @Effect()
  loadBestSellingProductsByCategory = combineLatest([
    this.store.pipe(select(getConfigCategories), distinctUntilChanged()),
    this.priceTypeService.priceType$
  ]).pipe(
    filter(([ categories, priceType ]) => {
      return !!priceType && !!categories && categories.length !== 0;
    }),
    map(([categories]) => categories.map(c => c.slug)),
    switchMap((slugs) => {
      return of(new LoadBestSellingProducts( { categorySlugs: slugs }));
    })
  );

  constructor(
    private actions$: Actions,
    private store: Store,
    private bestSellingProductsService: BestSellingProductsService,
    private priceTypeService: PriceTypeService
  ) {
  }
}
